import * as actions from "../actions";
import connect from "react-redux/es/connect/connect";
import TableHeader from "@common/components/TableHeader.jsx";

const mapStateToProps = (state, ownProps) => {
    return {
        columns: ownProps.columns
    }
};

const mapDispatchToProps = dispatch => {
    return {
        onWindowResize: clientWidth => dispatch(actions.setDefaultColumnsWidth(clientWidth)),
        onColumnResize: (newWidth, column) => dispatch(actions.columnResized(newWidth, column)),
        onSaveColumnWidth: (width, column) => dispatch(actions.saveColumnWidth(width, column)),
        loadColumnsWidth: () => dispatch(actions.loadColumnsWidth())
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(TableHeader);